const phrases = [
  "ENTRÜMPELUNGEN",
  "HAUSHALTSAUFLÖSUNGEN",
  "KLEINERE UMZÜGE",
  "MÜLLHEIM & MARKGRÄFLERLAND",
  "PERSÖNLICH & ZUVERLÄSSIG",
];

export default function EditorialMarquee() {
  return (
    <div className="editorial-marquee" data-testid="editorial-marquee-wrapper" aria-label="Unsere Leistungen">
      <div className="marquee-track">
        {[...phrases, ...phrases].map((phrase, index) => (
          <span className="marquee-item" key={`${phrase}-${index}`}>
            {phrase}<b>///</b>
          </span>
        ))}
      </div>
    </div>
  );
}
